import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import {
    Button,
    Icon,
    Modal,
    Table,
    message,
    DatePicker,
    Pagination,
} from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class MttDataStatistic extends React.Component {
    state = {
        loading: false, // 是否加载中
        matchSummaryLoading: false, // 赛事汇总数据是否加载中
        exportLoading: false, // 导出是否加载中
        exportMatchDataLoading: false, // 导出单日比赛数据统计是否加载中
        exportMatchSummaryLoading: false, // 导出导出单日赛事汇总数据是否加载中
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            date: [],
        },
        subQueryParams: {
            // 赛事汇总查询参数
            page: 1,
            limit: 20,
            day: undefined,
            total: 0,
        },
        selectedData: {}, // 选中数据
        data: [], // 表格数据
        matchSummaryList: [], // 赛事汇总
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/mtt/stat_list/v1", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取赛事汇总数据
     */
    fetchMatchSummaryList = () => {
        this.setState({ matchSummaryLoading: true });
        axios
            .get("/v1/api/mtt/day_match_list", {
                params: {
                    ...this.state.subQueryParams,
                    day: this.state.selectedData.begin_date,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    matchSummaryLoading: false,
                    subQueryParams: {
                        ...this.state.subQueryParams,
                        total: res.count || 0,
                    },
                    matchSummaryList: res.data || [],
                });
            });
    };

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/mtt/stat_list_export/v1", {
                params: {
                    page: this.state.queryParams.page,
                    limit: this.state.queryParams.limit,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 导出单日比赛数据统计
     */
    handleMatchDataExport = (item) => {
        this.setState({ exportMatchDataLoading: true });
        axios
            .get("/v1/api/mtt/day_match_list_export", {
                params: {
                    day: item.begin_date,
                },
            })
            .then((res) => {
                this.setState({ exportMatchDataLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 导出单日赛事汇总数据
     */
    handleMatchSummaryExport = (item) => {
        this.setState({ exportMatchSummaryLoading: true });
        axios
            .get("/v1/api/mtt/match_rank_detail_export", {
                params: {
                    mid: item.mid,
                },
            })
            .then((res) => {
                this.setState({ exportMatchSummaryLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "data") {
            // 数据分页
            this.setState(
                {
                    queryParams: {
                        ...this.state.queryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchData()
            );
        } else if (type === "matchSummary") {
            // 手牌详情数据
            this.setState(
                {
                    subQueryParams: {
                        ...this.state.subQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchMatchSummaryList()
            );
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    /**
     * 显示弹窗
     */
    handleShow = (item) => {
        this.setState(
            {
                show: true,
                title: this.props.language["eventSummary"],
                matchSummaryList: [],
                selectedData: item,
                subQueryParams: {
                    ...this.state.subQueryParams,
                    page: 1,
                },
            },
            () => this.fetchMatchSummaryList()
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={(pagination) => this.hanldeChangePage(pagination, "data")}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="begin_date"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["applyPeopleNumber"]}
                            dataIndex="register_num_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["applyPeopleTime"]}
                            dataIndex="register_count_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["rebuyHand"]}
                            dataIndex="rebuy_count_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["addonHand"]}
                            dataIndex="add_on_count_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["enterFee"]}
                            dataIndex="fee_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFee"]}
                            dataIndex="fee_svc_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ticketApply"]}
                            dataIndex="entry_ticket_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["bonusPayment"]}
                            dataIndex="bonus_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["profit"]}
                            dataIndex="gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["winnerPeople"]}
                            dataIndex="award_num_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={280}
                            render={(item) => (
                                <>
                                    <Button
                                        type="default"
                                        icon="area-chart"
                                        className="mr10"
                                        onClick={() => this.handleShow(item)}
                                    >
                                        {this.props.language["eventSummary"]}
                                    </Button>
                                    <Button
                                        type="default"
                                        icon="arrow-down"
                                        className="btn-yellow-ghost"
                                        // loading={this.state.exportMatchDataLoading}
                                        onClick={() => this.handleMatchDataExport(item)}
                                    >
                                        {this.props.language["exportExcel"]}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 赛事汇总弹窗 */}
                <MatchSummaryModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    loading={this.state.matchSummaryLoading}
                    exportMatchSummaryLoading={this.state.exportMatchSummaryLoading}
                    pagination={{
                        showTotal: (total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                        showQuickJumper: true,
                        current: this.state.subQueryParams.page,
                        pageSize: this.state.subQueryParams.limit,
                        total: this.state.subQueryParams.total,
                        size: isMobileDevice() ? 'small' : '',
                    }}
                    matchSummaryList={this.state.matchSummaryList}
                    handleMatchSummaryExport={this.handleMatchSummaryExport}
                    onCancel={() => this.setState({ show: false })}
                    onChange={(pagination) =>
                        this.hanldeChangePage({ current: pagination }, "matchSummary")
                    }
                />
            </div>
        );
    }
}

/**
 * 赛事汇总弹窗
 */
class MatchSummaryModal extends React.Component {
    render () {
        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={this.props.title}
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: '70vh',
                    overflowY: "auto",
                }}
                footer={
                    <Pagination
                        showQuickJumper
                        {...this.props.pagination}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        onChange={this.props.onChange}
                    />
                }
            >
                <div className="container-content">
                    <Table
                        dataSource={this.props.matchSummaryList}
                        pagination={false}
                        loading={this.props.loading}
                        onChange={this.props.onChange}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="begin_date"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["competition"]}
                            dataIndex=""
                            render={(item) => {
                                return `${item.name}(${item.mid})`;
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["startMatchTime"]}
                            dataIndex="begin_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["status"]}
                            dataIndex="status"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["applyFee"]}
                            dataIndex="entry_fee"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceRatio"]}
                            dataIndex="fee_rate"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["applyPeopleNumber"]}
                            dataIndex="register_num_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["applyPeopleTime"]}
                            dataIndex="register_count_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["rebuyTime"]}
                            dataIndex="rebuy_count_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["addonTime"]}
                            dataIndex="add_on_count_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["enterFee"]}
                            dataIndex="fee_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFee"]}
                            dataIndex="fee_svc_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ticketApply"]}
                            dataIndex="entry_ticket_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["bonusPayment"]}
                            dataIndex="bonus_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["profit"]}
                            dataIndex="gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["winnerPeople"]}
                            dataIndex="award_num_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["matchDurationTime"]}
                            dataIndex="time_range"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={140}
                            render={(item) => {
                                return (
                                    item.export && (
                                        <Button
                                            type="default"
                                            icon="arrow-down"
                                            className="btn-yellow-ghost"
                                            // loading={this.props.exportMatchSummaryLoading}
                                            onClick={() => this.props.handleMatchSummaryExport(item)}
                                        >
                                            {this.props.language["exportExcel"]}
                                        </Button>
                                    )
                                );
                            }}
                        />
                    </Table>
                </div>
            </Modal>
        );
    }
}
